import { css } from '@compiled/react';
import { useIntl } from 'react-intl';

import { wacToken } from '@/libraries/design/foundations';

export const InlineSeparator = () => {
	const intl = useIntl();
	const separatorText = intl.formatMessage({
		id: 'embeddedSignup.separator.or',
		defaultMessage: 'or',
	});

	return <span css={inlineSeparatorCss}>{separatorText}</span>;
};

const inlineSeparatorCss = css({
	alignSelf: 'center',
	color: wacToken('color.primary.black'),
	flexShrink: 0,
	fontFamily: wacToken('font.charlie.text'),
	fontSize: '18px',
	lineHeight: '28px',
	textAlign: 'center',
	whiteSpace: 'nowrap',
});
